'use client';
import { useState, useCallback } from 'react';
import { atomicFetch } from '../atomicFetch.js';
import { defaultResponseTransform } from '../defaultResponseTransform.js';
import { DEFAULT_CLIENT } from '../defaults.js';
import { useInvalidationNotifier } from '../invalidation/useInvalidationNotifier.js';
import { requestHash } from '../../utils/requestHash/requestHash.js';
import { handleErrorTransform } from '../../handleErrorTransform/handleErrorTransform.js';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
const useMutationImpl = (options = {})=>{
    const { onSuccess, onError, onFinish, client = DEFAULT_CLIENT } = options;
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);
    const notifyQueries = useInvalidationNotifier();
    const forceHiddenMutation = /*#__PURE__*/ _async_to_generator(function*(options) {
        const { query, transform = defaultResponseTransform, transformError, invalidate } = options;
        let data = null;
        try {
            const hash = requestHash(query);
            const response = yield atomicFetch(hash, client, query);
            const result = yield transform(response.clone());
            data = result;
            if (invalidate) {
                notifyQueries(invalidate, result);
            }
            setError(null);
            setData(result);
            onSuccess == null ? void 0 : onSuccess(result);
        } catch (error) {
            const finalError = yield handleErrorTransform(error, transformError);
            setError(finalError);
            onError == null ? void 0 : onError(finalError);
        } finally{
            onFinish == null ? void 0 : onFinish();
        }
        return data;
    });
    const mutate = useCallback(/*#__PURE__*/ _async_to_generator(function*(options) {
        setLoading(true);
        const result = yield forceHiddenMutation(options);
        setLoading(false);
        return result;
    }), []);
    const reset = useCallback(()=>{
        setLoading(false);
        setError(null);
        setData(null);
    }, []);
    return [
        mutate,
        {
            data,
            loading,
            error,
            reset
        }
    ];
};

export { useMutationImpl };
//# sourceMappingURL=useMutation.js.map
